export const PATHS = {
  home: "/",
  about: "/About",
  scheduleCall: "/ScheduleCall",
  terms: "/terms-and-conditions",
  policy: "/policy",
  login: "/login",
  newsletterAdmin: "/MessageNewsLetter",
  businessAdministration: "/BusinessAdministration",
  creativeServices: "/CreativeServices",
  customerSupport: "/CustomerSupport",
  marketing: "/Marketing",
  salesSolutions: "/SalesSolutions",
  softwareDevelopment: "/SoftwareDevelopment",
};

export const HASH_SECTIONS = [
  { id: "Services", to: "/#Services", label: "Services" },
  { id: "About", to: "/#About", label: "About Us" },
  { id: "Strategy", to: "/#Strategy", label: "Strategy Call" },
  { id: "Inquiry", to: "/#Inquiry", label: "Submit an Inquiry" },
  { id: "Clients", to: "/#Clients", label: "What Our Clients Say" },
];
